import React from "react"

import TasksView_Column from "../../../../../../model2/column/column"
import {
    AggregateFunctionLabel,
    AggregateFunctionType
} from "../../../../../../data-structures/aggregators/types"
import AggregateShellComponent from "../../../../../../gd-modules/common/aggregate/aggregate-shell"
import formatTime from "../../../../../../gd/format/time"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldTimeOfDay_AggregateCell"
const debug = false

export default function FieldTimeOfDay_AggregateCell(props: Props) {

    const isValid = !_.isNil(props.value)


    // Determine label to show when there is no data, depending on the aggregate function type
    let noDataLabel
    switch (props.column.aggregateFunction) {
        case AggregateFunctionType.SUM:
            noDataLabel = ''
            break

        default:
            noDataLabel = props.column.aggregateFunction
                ? AggregateFunctionLabel[props.column.aggregateFunction]
                : ''
            break
    }

    let valueLabel
    let showLabel: boolean = true
    if (isValid) {
        if (props.value.start) {
            showLabel = false
            valueLabel = '{0} - {1}'.f(formatTime(props.value.start), formatTime(props.value.end))
        } else {
            valueLabel = formatTime(props.value)
        }
    }

    // Get available aggregate function options for this field, if any
    const options = props.column.field?.getAggregateOptions()

    debug && console.log(debug, 'render', valueLabel, props.value)

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {valueLabel}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <>
                    {showLabel &&
                        <div className="aggregate-label">
                            {AggregateFunctionLabel[props.column.aggregateFunction!]}:
                        </div>}
                    <div className="aggregate-value aggregate-number">
                        {valueLabel}
                    </div>
                </>}

            {!isValid &&
                <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    )
}
